var Handlebars = require("../../../../handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(__default(require("../../../../../src/helpers/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"No thumbnail available",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":30}}}))
    + "\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /~/eoxc/src/core/views/RecordItemViewImageError.hbs
// module id = 2034
// module chunks = 0